import Confirm from '../components/Confirm.vue';

export default [
    {
        path: '/confirm/:token',
        component: Confirm,
        name: 'confirm'
    },
]
